import React, { useRef, useState } from 'react';

import { ExportContextProvider } from 'lib/context/ExportContext/ExportContextProvider';
import { ia } from 'lib/helpers/utility';

import Loading from 'components/shared/Loading/Loading';
import Modal from 'components/shared/Modal/Modal';

import InvoiceCreate from './InvoiceCreate';
import InvoicePreview from './InvoicePreview';
import InvoiceStepModalFooter from './InvoiceStepModalFooter';
import PatientSearch from './PatientSearch';
import InvoiceModalHeader from './lib/components/InvoiceModalHeader';

const InvoiceStepModal = ({ item: invoice, isOpen, isLoading, handleClose, selectedRows }) => {
  const invoiceCreateRef = useRef();

  const [step, setStep] = useState();
  const [groupSelectedRows, setGroupSelectedRows] = useState();

  const isFromSelectedRows = selectedRows?.length > 0 || invoice;
  const finalSelectedRows = groupSelectedRows || selectedRows || (invoice ? [invoice] : []);
  const finalStep = step || (ia(selectedRows) || invoice ? 1 : 0);

  const [externalInvoices, setExternalInvoices] = useState([]);

  const handleStepChange = (increment) => {
    const newStep = finalStep + (increment ? 1 : -1);
    if (!increment && selectedRows?.length > 0 && newStep === 0) {
      return;
    }
    setStep(newStep);
  };

  const steps = {
    0: <PatientSearch setGroupSelectedRows={setGroupSelectedRows} />,
    1: (
      <InvoiceCreate
        ref={{ invoiceCreateRef }}
        selectedRows={finalSelectedRows}
        setExternalInvoices={setExternalInvoices}
        setStep={setStep}
      />
    ),
    2: <InvoicePreview externalInvoices={externalInvoices} selectedRows={finalSelectedRows} />
  };

  return (
    <ExportContextProvider category="invoice">
      <Modal
        isLarge
        slideFromRight
        isOpen={isOpen}
        handleClose={handleClose}
        customHeader={[1, 2].includes(finalStep) && <InvoiceModalHeader />}
        footer={
          <InvoiceStepModalFooter
            step={finalStep}
            handleClose={handleClose}
            handleStepChange={handleStepChange}
            invoiceCreateRef={invoiceCreateRef}
            externalInvoices={externalInvoices}
            finalGroupInvoices={finalSelectedRows}
            isFromSelectedRows={isFromSelectedRows}
          />
        }>
        {isLoading ? <Loading /> : steps[finalStep]}
      </Modal>
    </ExportContextProvider>
  );
};

export default InvoiceStepModal;
